module.exports = __webpack_public_path__ + "ea0b1e963af36a5876df9bc538fca665.jpeg";


//////////////////
// WEBPACK FOOTER
// ./client/assets/img/sky.jpeg
// module id = 640
// module chunks = 0